import { useNavigate } from "react-router-dom";
import ScrollToTopButton from "../../components/ScrollToTopButton";
import { Banner, BlueLarge } from "../../images/index";
import {
  Image311,
  OurSupplyImage,
  G14,
  G15,
  G16,
  G17,
  Image310,
  Image312,
  Image341,
} from "../../images/Industries";
import { useEffect, useState } from "react";
import { getPagesBySlug } from "../../services/apiService";
import useSlug from "../SlugComp";
import SEO from "../Seo";

const challenges = [
  "Disruptions in global supply networks",
  "Rising operational costs and fuel inefficiencies",
  "Lack of visibility across complex supply chains",
  "Increasing CyberSecurity threats in connected logistics",
  "Growing need for real-time data and demand forecasting",
];

const features = [
  {
    icon: G14,
    text: "Proven expertise with global logistics and wholesale distribution leaders",
  },
  {
    icon: G15,
    text: "AI/ML frameworks designed for forecasting & automation",
  },
  {
    icon: G16,
    text: "Hybrid U.S.–India delivery for 24/7 operations and cost efficiency",
  },
  {
    icon: G17,
    text: "Experience integrating with ERP, warehouse, and transport systems",
  },
];

function LSC() {
  const navigate = useNavigate();
  const slug = useSlug();
  const [metaData, setMetaData] = useState({});
  useEffect(() => {
    const fetchMetaData = async () => {
      const data = await getPagesBySlug(slug);
      setMetaData(data?.meta || {});
    };
    fetchMetaData();
  }, [slug]);
  const handleClick = () => {
    navigate("/contact");
  };
  return (
    <>
      <SEO {...metaData} />
      <div>
        <div className="relative min-h-[500px]">
          <img
            src={Banner}
            alt="About Banner"
            className="absolute inset-0 -z-10 md:h-full h-[calc(100vh-0px)] w-full object-cover"
          />

          <div className="absolute flex items-center justify-between h-full sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto left-0 right-0 px-8 sm:px-6 md:px-8 lg:px-8 xl:px-0">
            <div className="max-w-[45rem] font-roboto space-y-6 mt-16">
              <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
                <span className="w-[21px] h-[6px] bg-activeColor"></span>
                <span className="w-[36px] h-[6px] bg-activeColor"></span>
                <span className="text-[#475569]">Logistics & Supply Chain</span>
              </span>
              <h1 className="text-4xl md:text-7xl text-[#29327f] font-bold">
                Building Smarter, Faster Supply Chains
              </h1>
              <p className="text-md text-[#404040] max-w-3xl">
                TechProjects helps logistics providers and global supply chains
                stay efficient, secure, and data-driven with digital platforms,
                AI, and automation.
              </p>
            </div>

            <div className="max-w-xl flex justify-end mt-16">
              <img src={Image341} alt="Image" className="obkect-contain" />
            </div>
          </div>
        </div>

        <section className="py-14 px-4 md:px-20 font-roboto bg-[#F7F7F7]">
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto items-center md:items-center justify-between md:px-0 px-6 gap-10">
            <div className="mb-12">
              <h2 className="text-6xl font-extrabold text-[#434253] mb-3">
                Challenges in the Industry
              </h2>
            </div>

            <div className="flex flex-col lg:flex-row items-center gap-10">
              <div className="flex-1 w-full mb-10">
                <ul className="space-y-7 ms-5">
                  {challenges.map((item, idx) => (
                    <li
                      key={idx}
                      className="list-disc text-xl text-[#0F172A] font-medium"
                    >
                      {item}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="flex-1 flex items-center justify-center">
                <img
                  src={Image311}
                  alt="Idea Concept"
                  className="max-w-md w-full object-contain"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 px-4 md:px-20 font-roboto bg-white">
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto items-center md:items-center justify-between md:px-0 px-6 gap-10">
            <div className="max-w-4xl mx-auto mb-12 text-center">
              <span className="flex items-center justify-center font-bold text-lg tracking-wider mb-4 space-x-2">
                <span className="w-[21px] h-[6px] bg-activeColor"></span>
                <span className="w-[36px] h-[6px] bg-activeColor"></span>
              </span>
              <h2 className="text-6xl font-extrabold text-[#434253] mb-3">
                Our Supply Chain Solutions
              </h2>
              <p className="text-[#404040] font-400 text-lg text-base">
                Our Supply Chain Solutions
              </p>
            </div>
            <img
              src={OurSupplyImage}
              alt="Our Supply Chain Solutions"
              className="inset-0 -z-10 md:h-full w-full object-cover"
            />
            <a
              href="#"
              className="text-[#FA3746] text-xl font-bold flex items-center w-full justify-center gap-2"
            >
              Explore Our Services{" "}
              <i className="fa fa-arrow-right text-xs mt-1"></i>
            </a>
          </div>
        </section>

        <section className="bg-[#F7F7F7] py-16 px-2 font-roboto">
          <div className="flex justify-center mb-4">
            <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
              <span className="w-[21px] h-[6px] bg-activeColor"></span>
              <span className="w-[36px] h-[6px] bg-activeColor"></span>
            </span>
          </div>

          <h2 className="text-5xl md:text-7xl font-extrabold text-[#434253] text-center mb-6 px-6 md:px-0">
            Why TechProjects for Logistics?
          </h2>
          <p className="text-center text-lg text-[#404040] mb-14 font-400 tracking-tight">
            Wholesale Grocery Leader – AI Demand Forecasting
          </p>
          <div className="max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 px-6 md:px-0">
            {features.map((feature, idx) => (
              <div key={idx} className="flex items-center bg-white p-8">
                <img src={feature.icon} alt={feature.text} className="mr-6" />
                <span className="text-lg text-[#0F172A] font-400">
                  {feature.text}
                </span>
              </div>
            ))}
          </div>
          <a
            href="#"
            className="text-[#FA3746] text-xl font-bold flex items-center w-full justify-center gap-2 mt-12"
          >
            Partner With Us <i className="fa fa-arrow-right text-xs mt-1"></i>
          </a>
        </section>

        <section className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto bg-white py-16 px-2 font-roboto">
          <div className="flex justify-center mb-3">
            <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
              <span className="w-[21px] h-[6px] bg-activeColor"></span>
              <span className="w-[36px] h-[6px] bg-activeColor"></span>
            </span>
          </div>

          <h2 className="text-4xl md:text-7xl font-extrabold text-[#434253] text-center mb-4">
            Impact & Case Studies
          </h2>

          <div className="text-center text-lg text-[#404040] mx-auto max-w-5xl mb-12 font-400">
            We help logistics and supply chain leaders optimize operations with
            AI, automation, and real-time visibility. Here are a few examples of
            the results we’ve delivered.
          </div>

          <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-12 px-8 sm:px-6 md:px-8 lg:px-8 xl:px-0">
            <div className="flex-1 flex justify-center">
              <img
                src={Image312}
                alt="Case studies discussion"
                className="object-cover w-full max-w-md"
              />
            </div>
            <div className="flex-1 px-8 md:px-0">
              <ul className="list-disc space-y-4 text-lg text-[#0F172A]">
                <li>
                  <span className="font-bold">Global Wholesaler</span>
                  <ul className="list-disc ml-5 mt-2 text-base text-lg text-[#475569]">
                    <li>15% reduction in spoilage</li>
                    <li>
                      Implemented AI-powered demand forecasting to improve
                      inventory planning and reduce waste.
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="font-bold"> Logistics Firm</span>
                  <ul className="list-disc ml-5 mt-2 text-base text-lg text-[#475569]">
                    <li>60% less manual work</li>
                    <li>
                      Automated freight documentation processes, cutting down
                      repetitive tasks and boosting efficiency.
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="font-bold">Supply Chain Network</span>
                  <ul className="list-disc ml-5 mt-2 text-base text-lg text-[#475569]">
                    <li>Improved delivery accuracy & trust</li>
                    <li>
                      Built a real-time visibility dashboard, enhancing
                      reliability and customer satisfaction.
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </section>

        <section
          className="text-white flex items-center py-8 md:py-[4rem] relative overflow-hidden bg-cover bg-no-repeat font-roboto"
          style={{ backgroundImage: `url(${BlueLarge})` }}
        >
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto text-center px-3 md:px-6">
            <h2 className="text-3xl md:text-4xl xl:text-6xl max-w-4xl mx-auto font-extrabold text-white leading-tight mb-[2rem] md:mb-[3rem]">
              Logistics & Supply Chain
            </h2>
            <p className="text-lg font-400 text-[#CBD5E1] max-w-3xl  mx-auto">
              With TechProjects, you can improve operational visibility,
              accelerate fulfillment, and reduce supply chain costs — enabled by
              AI and intelligent automation.
            </p>
            <div className="flex flex-wrap  justify-center mt-10 gap-6 md:gap-12">
              <button
                onClick={handleClick}
                type="submit"
                className="bg-activeColor text-white text-lg md:text-2xl px-5 md:px-6 py-2 md:py-3 rounded-md font-medium hover:bg-red-600 transition-all flex items-center gap-4"
              >
                Contact Us Now
              </button>
            </div>
          </div>
        </section>

        <ScrollToTopButton />
      </div>
    </>
  );
}

export default LSC;
